import { useEffect, useState } from "react";
import Fade from "../../components/Fade";
import LogoFooter from "../../components/LogoFooter";
import Loading from "../../components/Loading";
import { useNavigate } from "react-router-dom";
import DelayedLinkWithFadeout from "../../components/utils/DelayedLinkWithFadeout";

export default function Servico() {
  const PLACEHOLDER_TEXT = "Toque para selecionar o serviço prestado";

  const [servicos, setServicos] = useState(null);
  const [servico, setServico] = useState(null);
  const [erroServico, setErroServico] = useState(null);
  const [isOpen, setIsOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/servicos`, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((data) => {
        setServicos(data);
      })
      .catch((error) => console.log(error));
  }, []);

  const handleSelectChange = (servicoId) => {
    setServico(servicoId);
    setErroServico(null);
    setIsOpen(false);
  };

  const handleToggleOpen = () => {
    setIsOpen((prev) => !prev);
    setErroServico(null);
  };

  const handleAdvance = () => {
    if (!servico) {
      setErroServico("Campo obrigatório");
      setIsOpen(false);
      return;
    }

    navigate("/pesquisa", {
      state: { servico },
    });
  };

  const servicoSelecionado = servicos?.find((s) => s.id === servico);
  const labelServico = servicoSelecionado?.nome || PLACEHOLDER_TEXT;

  return (
    <>
      <Fade>
        <div className="w-full min-h-screen flex flex-col justify-between px-12 pt-12 pb-4">
          <div className="flex flex-col flex-1">
            <div className="mb-12">
              <h1 className="text-6xl font-bold text-deepBlue">
                Pesquisa de avaliação do serviço
              </h1>
            </div>

            <div className="mb-12 max-w-5xl">
              <p className="text-3xl font-bold text-deepBlue mb-3">
                Prezado(a) cidadão(ã),
              </p>
              <p className="text-2xl text-deepBlue leading-relaxed">
                Esta pesquisa tem como objetivo avaliar a qualidade do serviço
                prestado por este órgão, contribuindo para a melhoria contínua
                do atendimento. As respostas são anônimas.
              </p>
            </div>

            <div className="flex mb-20">
              {servicos ? (
                <div className="w-full max-w-4xl relative">
                  <button
                    onClick={handleToggleOpen}
                    className={`w-full px-6 py-4 text-2xl bg-white border-2 border-[#c6d3df] text-left text-gray-700 cursor-pointer focus:outline-none flex justify-between items-center transition ${
                      isOpen
                        ? "rounded-t-3xl rounded-b-none border-b-0"
                        : "rounded-3xl"
                    }`}
                  >
                    <span className="text-gray-600">{labelServico}</span>
                    <svg
                      className={`w-7 h-7 text-black transition-transform duration-300 flex-shrink-0 ${
                        isOpen ? "rotate-180" : ""
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 9l6 6 6-6"
                      />
                    </svg>
                  </button>

                  {isOpen && (
                    <div className="absolute top-full left-0 right-0 mt-0 bg-white border-2 border-[#c6d3df] border-t-0 rounded-b-3xl shadow-lg z-10 max-h-96 overflow-y-auto">
                      {servicos.map((servicoItem) => (
                        <button
                          key={servicoItem.id}
                          onClick={() => handleSelectChange(servicoItem.id)}
                          className="w-full px-6 py-3 text-left text-gray-800 hover:bg-gray-50 text-2xl transition"
                        >
                          {servicoItem.nome}
                        </button>
                      ))}
                    </div>
                  )}

                  {erroServico && (
                    <span className="text-red-500 text-base mt-3 block">
                      {erroServico}
                    </span>
                  )}
                </div>
              ) : (
                <Loading size={48} color="text-deepBlue" />
              )}
            </div>
          </div>

          <div className="w-full flex items-center justify-between mt-auto">
            <div className="flex gap-6 items-center">
              <DelayedLinkWithFadeout to="/">
                <button className="min-w-[200px] py-4 border-2 border-deepBlue text-deepBlue px-12 rounded-2xl text-3xl font-semibold transition">
                  Voltar
                </button>
              </DelayedLinkWithFadeout>
              <button
                onClick={handleAdvance}
                className="min-w-[200px] py-4 bg-deepBlue text-white px-12 rounded-2xl text-3xl font-semibold hover:bg-opacity-90 transition"
              >
                Avançar
              </button>
            </div>

            <div className="p-6">
              <LogoFooter />
            </div>
          </div>
        </div>
      </Fade>
    </>
  );
}
